import type { ComponentPropsWithoutRef, FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { AnimationWrapper } from '../AnimationWrapper'
import { TypographyV2 } from '../Seatbelt2/Foundations/Typography'
import styles from './Radio.module.scss'

export const Radio: FunctionComponent<Props> = ({
  checked = false,
  className,
  disabled = false,
  id,
  label,
  name,
  value,
  ...rest
}) => {
  return (
    <div className={classnames(styles.radioWrapper, className)} data-testid="radio">
      <div
        className={classnames(styles.radioWrapperItem, {
          [styles.radioWrapperItemDisabled]: disabled,
        })}
      >
        <input
          checked={checked}
          className={classnames(styles.radioButton, {
            [styles.radioButtonDisabled]: disabled,
          })}
          disabled={disabled}
          id={id}
          name={name}
          type="radio"
          value={value}
          {...rest}
        />
        <TypographyV2
          className={classnames(styles.radioWrapperLabel, {
            [styles.radioWrapperLabelDisabled]: disabled,
            [styles.radioWrapperLabelChecked]: checked,
            [styles.radioWrapperLabelCheckedDisabled]: disabled && checked,
          })}
          tag="label"
          textStyle="sb-text-interface-body-default-regular"
          htmlFor={id}
        >
          {disabled ? label : <AnimationWrapper inverted>{label}</AnimationWrapper>}
        </TypographyV2>
      </div>
    </div>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  checked?: boolean
  className?: string
  disabled?: boolean
  id: string
  label: string
  name: string
  value: string
} & ComponentPropsWithoutRef<'input'>
